import useDownloadHelper from "../../../hooks/useDownloadHelper";
import './downloadQueue.css';
import {getFileExtension, getFileName, isMobileDevice} from "../../../utils/utils";
import FileQueueLine from "../driveContextualMenu/fileUploadMenu/fileQueueLine/fileQueueLine";
import React, {useEffect, useState} from "react";

const DownloadQueue = () => {
    const {queue, currentFile, downloadSpeed, progress, abortDownload} = useDownloadHelper();
    const [file, setFile] = useState(null);

    useEffect(() => {
        if (currentFile) {
            setFile(currentFile);
        }
    }, [currentFile])

    return (
        <div
            className={"download-queue alert alert-info " + (currentFile ? "" : "download-queue__hidden") + (isMobileDevice() ? "" : " download-queue__pc-view")}>
            <FileQueueLine
                downloadSpeed={downloadSpeed}
                onDelete={abortDownload}
                file={file}
                name={getFileName(file?.fileName ?? "")}
                extension={getFileExtension(file?.fileName ?? "")}
                progress={progress}/>
        </div>
    )
}

export default DownloadQueue;
